// extracted by mini-css-extract-plugin
module.exports = {"media":"ContentfulMedia_media__CiFfV","square":"ContentfulMedia_square__ZumL2","round":"ContentfulMedia_round__XnJdZ","header":"ContentfulMedia_header__g34Bz"};